import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CodePreview = ({ code, language = 'javascript' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative rounded-lg bg-primary border border-border overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2 bg-secondary border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Code2" size={16} color="var(--color-accent)" />
          <span className="text-xs font-medium text-muted-foreground uppercase">{language}</span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleCopy}
          iconName={copied ? "Check" : "Copy"}
          iconSize={14}
        >
          {copied ? 'Скопировано' : 'Копировать'}
        </Button>
      </div>
      
      <div className="p-4 overflow-x-auto">
        <pre className="text-sm text-foreground font-accent">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodePreview;